<div *ngIf="attributions && attributions.length > 0" class="row attributions">
    <div
        *ngFor="let item of attributions"
        class="attribution col-sm-6 col-md-6 col-lg-4 col-xl-2 selenium-attribution"
    >
        <app-logo [logoUrl]="item.logoColor" [name]="item.name" [role]="item.getRoles()"></app-logo>
    </div>
</div>
